import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { IHeaderAngularComp } from 'ag-grid-angular';
import type { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-header',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="custom-header" (click)="onSortRequested($event)" style="cursor: pointer; display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <div>
        <span>Total AF</span>
        <br/>
        <small style="font-size: 11px; line-height: 1.2; display: inline-block;">
          Prior to 01/01/2025,<br>amounts included UAB
        </small>
      </div>

      <!-- Custom Sort Icons -->
      <span class="sort-icons" style="margin-left: 8px; font-size: 12px;">
        <span *ngIf="sortState() === 'asc'">▲</span>
        <span *ngIf="sortState() === 'desc'">▼</span>
      </span>
    </div>
  `,
})
export class CustomHeader implements IHeaderAngularComp {
  public params!: IHeaderParams;
  public sortState = signal<'asc' | 'desc' | null>(null);

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    this.onSortChanged();
  }

  // Handle the sort cycle manually inside the component
  onSortRequested(event: MouseEvent): void {
    const currentSort = this.params.column.getSort();
    let nextSort: 'asc' | 'desc' | null = null;

    // Cycle: None -> Asc -> Desc -> None
    if (!currentSort) {
      nextSort = 'asc';
    } else if (currentSort === 'asc') {
      nextSort = 'desc';
    } else {
      nextSort = null; // Clears the sort
    }

    // Explicitly apply the sort to the grid (handles multi-sorting with Shift key)
    this.params.setSort(nextSort, event.shiftKey);
  }

  onSortChanged(): void {
    const currentSort = this.params.column.getSort();
    this.sortState.set(currentSort ? (currentSort as 'asc' | 'desc') : null);
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return true;
  }
}
